import { ApiError } from '../../shared/api/client'

export function deckErrorText(e: unknown): string {
  if (e instanceof ApiError) return e.message
  return 'Не получилось. Проверьте соединение и повторите'
}
